import { isLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { MaybeSearchPageCategoryRecommendationLink } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/MaybeSearchPageMainHeaderContent/__internal__/MaybeSearchPageCategoryRecommendationLink/MaybeSearchPageCategoryRecommendationLink";
import { SearchPageHeaderSearchResults } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/MaybeSearchPageMainHeaderContent/__internal__/SearchPageHeaderSearchResults";
import { useSearchPageShouldShowMainHeaderContent } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/MaybeSearchPageMainHeaderContent/__internal__/useSearchPageShouldShowMainHeaderContent";
import { useSearchPageShouldShowProductFirstPageSubheaderText } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/useSearchPageShouldShowProductFirstPageSubheaderText";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { SubHeader } from "@faire/deprecated-retailer-visitor-shared/views/search/__internal__/SearchProductsPage/__internal__/SearchStyles";
import { Core } from "@faire/design-tokens";
import { Spacer } from "@faire/web/slate/spacing";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

export const MaybeSearchPageMainHeaderContent = ({
  filterRef,
}: {
  filterRef?: React.MutableRefObject<HTMLDivElement | null>;
}) => {
  const shouldShowProductFirstPageSubheaderText =
    useSearchPageShouldShowProductFirstPageSubheaderText();

  if (!useSearchPageShouldShowMainHeaderContent()) {
    return <Spacer height={4} />;
  }

  return (
    <>
      <SearchPageHeaderSearchResults filterRef={filterRef} />
      {shouldShowProductFirstPageSubheaderText && !isLoggedInRetailer() ? (
        <>
          <Spacer height={2} />
          <SubHeader color={Core.text.subdued}>
            {getProductFirstPageSubheaderText()}
          </SubHeader>
        </>
      ) : null}
      <MaybeSearchPageCategoryRecommendationLink />
    </>
  );
};

const getProductFirstPageSubheaderText = () => (
  <StrictLocalMsg
    id="vr77m9"
    defaultMessage="Discover new products and enjoy free returns on all opening orders."
    description={{
      text: "Introducing new retailer about product category/search page",
      img: "https://cdn.faire.com/fastly/e425bb5151cb89a048b0833f814f55b4b7207130a84f2c4e7cd6d49513adaefe.png",
    }}
  />
);
